
import React, { useState } from 'react';
import { Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button, Spinner } from 'reactstrap';

import ResponseBox from './ResponseBox';

import { patchUser } from '../../helpers/satiBack';

const UserData = ({ user, updateUser }) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(0);

  const {
    nombre: name,
    email,
    empresa: { nombre: companyName },
    area: { nombre: areaName }
  } = user;

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setResponse(0);

    const { nombre, correo } = e.target.elements;
    const data = {
      nombre: nombre.value,
      correo: correo.value
    };

    patchUser(data)
      .then(resp => {
        setLoading(false);
        setResponse(1);
        updateUser();
      })
      .catch(err => {
        setLoading(false);
        setResponse(2);
      })
  }

  return (
    <Card>
      <CardBody>
        <h4>Datos de Usuario</h4>
        <Form className="mt-4" onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="usuarioNombre">Nombre completo</Label>
            <Input type="text" name="nombre" id="usuarioNombre" defaultValue={name}/>
          </FormGroup>
          <FormGroup>
            <Label for="usuarioCorreo">Correo</Label>
            <Input type="email" name="correo" id="usuarioCorreo" defaultValue={email}/>
          </FormGroup>
          <FormGroup>
            <Label for="usuarioEmpresa">Empresa</Label>
            <Input type="text" name="empresa" id="usuarioEmpresa" value={companyName} disabled/>
          </FormGroup>
          <FormGroup>
            <Label for="usuarioArea">Area</Label>
            <Input type="text" name="area" id="usuarioArea" value={areaName} disabled/>
          </FormGroup>
          <ResponseBox type={response}/>
          <Row>
            <Col>
              <Button type="submit" color="primary" className="float-right">
                Guardar
                {loading && (<Spinner size="sm" color="light" className="ml-2"/>)}
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  )
}

export default UserData;
